export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;

export const ALLOWED_FILE_EXTENSIONS = ['pdf', 'ppt', 'msg', 'docx', 'doc', 'png', 'jpg', 'jpeg', 'mpeg'] as const;

export const ALLOWED_FILE_MIME_TYPES = {
    pdf: 'application/pdf',
    ppt: 'application/vnd.ms-powerpoint',
    msg: 'application/vnd.ms-outlook',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    doc: 'application/msword',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    mpeg: 'video/mpeg'
} as const;

export function getFileExtension(fileName: string): string {
    return fileName.split('.').pop()?.toLowerCase() || '';
}

export function isAllowedFileType(fileName: string, contentType?: string): boolean {
    const extension = getFileExtension(fileName);
    if (!ALLOWED_FILE_EXTENSIONS.includes(extension as (typeof ALLOWED_FILE_EXTENSIONS)[number])) {
        return false;
    }

    return !contentType || ALLOWED_FILE_MIME_TYPES[extension as keyof typeof ALLOWED_FILE_MIME_TYPES] === contentType;
}
